export const CHAVES_STORAGE = {
  ANOS_REFERENCIAS: 'referenceYears',
  SELECIONAR_LOCALIZACAO: 'selectLocation',
  TIPO_SIMULACAO: 'simulationType',
  CHAVE_SESSAO_TIPO_SIMULACAO: 'simulationTypeSessionKey',
  CHAVE_SELECIONAR_LOCALIZACAO: 'selectLocationKey'
} as const;

export const CHAVES_FUNCIONALIDADE = {
  selecionarLocalizacao: {
    key: 'selectLocation'
  }
} as const;